export const ssoLabels = [
    {
        idpLabel: "Identity Provider",
        idp: "Microsoft Entra",
        applicationID: "Application ID",
        certPath: "Select Certificate Path",
        certPathLabel: "Select Certificate Path",
        loginURL: "Login URL",
        appIdPlaceholder: "Enter your Application ID",
        certPathPlaceholder: "Select your Certificate Path",
        certPathHelper:
            "Striim must be able to access the *.pem or *.cer file at all times to validate the users logging in",
        urlPlaceholder: "Enter your Login URL",
        signAuthnRequests: "Sign AuthnRequests",
        spKeystorePath: "SP Keystore Path",
        spKeyAlias: "Key Alias",
        spKeystorePassword: "Keystore Password",
        signatureAlgorithm: "Signature Algorithm",
        spKeystorePathPlaceholder: "Select your SP keystore file",
        spKeystorePathHelper: "PKCS12 keystore (.p12 or .pfx) containing the SP signing key",
        spKeyAliasPlaceholder: "Enter the key alias",
        spKeystorePasswordPlaceholder: "Enter the keystore password",
        spKeystorePasswordEditPlaceholder: "Leave blank to keep existing password"
    },
    {
        idpLabel: "Identity Provider",
        idp: "Okta",
        applicationID: "Issuer URL",
        certPath: "Select Certificate Path",
        certPathLabel: "Select Certificate Path",
        loginURL: "Sign On URL",
        appIdPlaceholder: "Enter your Issuer URL",
        certPathPlaceholder: "Select your Certificate Path",
        certPathHelper:
            "Striim must be able to access the *.pem or *.cer file at all times to validate the users logging in",
        urlPlaceholder: "Enter your Sign On URL",
        signAuthnRequests: "Sign AuthnRequests",
        spKeystorePath: "SP Keystore Path",
        spKeyAlias: "Key Alias",
        spKeystorePassword: "Keystore Password",
        signatureAlgorithm: "Signature Algorithm",
        spKeystorePathPlaceholder: "Select your SP keystore file",
        spKeystorePathHelper: "PKCS12 keystore (.p12 or .pfx) containing the SP signing key",
        spKeyAliasPlaceholder: "Enter the key alias",
        spKeystorePasswordPlaceholder: "Enter the keystore password",
        spKeystorePasswordEditPlaceholder: "Leave blank to keep existing password"
    },
    {
        idpLabel: "Identity Provider",
        idp: "PingFederate",
        applicationID: "Entity ID",
        certPath: "Certificate Path",
        certPathLabel: "Select Certificate Path",
        loginURL: "SSO Service URL",
        appIdPlaceholder: "Enter your Entity ID",
        certPathPlaceholder: "Select your Certificate Path",
        certPathHelper:
            "Striim must be able to access the *.pem or *.cer file at all times to validate the users logging in",
        urlPlaceholder: "Enter your SSO Service URL",
        signAuthnRequests: "Sign AuthnRequests",
        spKeystorePath: "SP Keystore Path",
        spKeyAlias: "Key Alias",
        spKeystorePassword: "Keystore Password",
        signatureAlgorithm: "Signature Algorithm",
        spKeystorePathPlaceholder: "Select your SP keystore file",
        spKeystorePathHelper: "PKCS12 keystore (.p12 or .pfx) containing the SP signing key",
        spKeyAliasPlaceholder: "Enter the key alias",
        spKeystorePasswordPlaceholder: "Enter the keystore password",
        spKeystorePasswordEditPlaceholder: "Leave blank to keep existing password"
    }
];

export const SIGNATURE_ALGORITHM_OPTIONS = [
    { label: "RSA-SHA256", value: "RSA-SHA256" },
    { label: "RSA-SHA512", value: "RSA-SHA512" }
];
